import { CodeSubject } from 'civil-status/constants/code-subject-section';
import { ID_APPLICANT } from 'civil-status/constants/id-applicant';
import { IdResidence } from 'civil-status/constants/id-residence';
import { initialConditionsItem } from 'civil-status/constants/initial-values-step';
import { typePresence } from 'civil-status/constants/type-presence';
import { ParentVM, SectionVM, SoggettoList } from 'civil-status/view-models/step-form';
import { ID_ALTRO_STATO } from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';
import { withIsSignatoryCheck } from '../with-is-signatory-check';

export const transformerSoggettoList = (
  subjects?: Array<ParentVM>,
  dataTranscription?: SectionVM
): Array<SoggettoList> | undefined => {
  if (subjects?.length === 0) {
    return undefined;
  }

  return subjects
    ?.filter((item) => Boolean(item.codeSubject))
    ?.map((item) => {
      const defaultFlag: string | undefined =
        item?.presenza === typePresence?.Default1 ? '0' : undefined;

      const isMadreApplicant =
        item.codeSubject === CodeSubject.MADRE &&
        dataTranscription?.applicant?.id === ID_APPLICANT.MADRE;
      const isPadreApplicant =
        item.codeSubject === CodeSubject.PADRE &&
        dataTranscription?.applicant?.id === ID_APPLICANT.PADRE;
      const isNascituroApplicant =
        (item.codeSubject === CodeSubject.INT_NAS ||
          item.codeSubject === CodeSubject.INT_NAS2 ||
          item.codeSubject === CodeSubject.INT_NAS2_C1) &&
        dataTranscription?.applicant?.id === ID_APPLICANT.SOGGETTO;
      const isRichiedenteApplicant =
        item.codeSubject === CodeSubject.RICHIEDENTE &&
        dataTranscription?.applicant?.id === ID_APPLICANT.ALTRO;

      const isOtherState = item?.generality?.foreign?.state?.code?.toString() === ID_ALTRO_STATO;
      const isOtherMunicipality =
        item.generality?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

      const isForeignResidence = item?.generality?.typeResidence === IdResidence.Foreign;
      const isItalianResidence = item?.generality?.typeResidence === IdResidence.Italian;
      const isNotKnownResidence = item?.generality?.typeResidence === IdResidence.NotKnown;

      return {
        key: {
          idSoggetto: item?.generality?.idSubject || null,
        },
        codiceFiscale: item?.generality?.fiscalCode?.toUpperCase() || undefined,
        cognome: item?.generality?.surname || undefined,
        nome: item?.generality?.name || undefined,
        idSoggettoAnpr: item?.generality?.idAnpr || undefined,
        idSoggettoAnsc: item?.generality?.idAnsc || undefined,
        idAnpr: item.generality?.idNationalIdentifier || undefined,
        sesso: item?.generality?.gender || undefined,
        tipoStatoCivile: item?.generality?.civilStatusItem?.id || undefined,
        descrizioneStatoCivile: item?.generality?.civilStatusItem?.value || undefined,
        dataNascita: item?.generality?.birthDate
          ? item?.generality?.birthDate?.toFormat('yyyy-MM-dd')
          : undefined,
        descrizioneNazionalita: item?.generality?.nationality?.value || undefined,
        codiceNazionalita: item?.generality?.nationality?.idAnpr || undefined,
        comuneNascita: item?.generality?.isForeignBorn
          ? item?.generality?.foreign?.municipality?.description || undefined
          : isOtherMunicipality
          ? item?.generality?.italian?.otherMunicipality || undefined
          : item?.generality?.italian?.municipality?.description,
        idComuneNascita: item?.generality?.isForeignBorn
          ? item?.generality?.foreign?.municipality?.id
            ? Number?.parseInt(item?.generality?.foreign?.municipality?.id, 10)
            : undefined
          : item?.generality?.italian?.municipality?.code?.toString()
          ? item?.generality?.italian?.municipality?.code
          : undefined,
        statoNascita: item?.generality?.isForeignBorn
          ? isOtherState
            ? item?.generality.foreign?.otherState
            : item?.generality?.foreign?.state?.value
          : item?.generality?.italian?.municipality?.description
          ? DESCRIPTION_ITALIAN_NATION
          : undefined,
        idStatoNascita:
          item?.generality?.isForeignBorn && item?.generality?.foreign?.state?.code
            ? Number?.parseInt(item?.generality?.foreign?.state?.code, 10)
            : item?.generality?.italian?.municipality?.description
            ? ID_ITALIAN_NATION
            : undefined,
        nomeLocalitaEsteraNascita:
          item?.generality?.isForeignBorn && item?.generality?.foreign?.locationForeignBirth
            ? item?.generality?.foreign?.locationForeignBirth
            : undefined,
        idProvNascita: item?.generality?.isForeignBorn
          ? // ? item?.generality?.foreign?.state?.istatCode
            //   ? Number?.parseInt(item?.generality?.foreign?.state?.istatCode, 10)
            undefined
          : Boolean(item?.generality?.italian?.municipality?.idProvince?.toString())
          ? item?.generality?.italian?.municipality?.idProvince
          : undefined,
        siglaProvNascita: item?.generality?.isForeignBorn
          ? item?.generality?.foreign?.municipality?.province || undefined
          : item?.generality?.italian?.municipality?.province || undefined,
        indirizzoResidenza: item?.generality?.address || undefined,
        siglaProvResidenza: isForeignResidence
          ? item?.generality?.foreignResidence?.municipality?.province || undefined
          : isItalianResidence
          ? item?.generality?.italianResidence?.municipality?.province || undefined
          : undefined,
        idProvResidenza:
          isForeignResidence && item?.generality?.foreignResidence?.municipality?.provinceCode
            ? Number?.parseInt(item?.generality?.foreignResidence?.municipality?.provinceCode, 10)
            : isItalianResidence
            ? item?.generality?.italianResidence?.municipality?.idProvince || undefined
            : undefined,
        idStatoResidenza:
          isForeignResidence && item?.generality?.foreignResidence?.state?.code
            ? Number?.parseInt(item?.generality?.foreignResidence?.state?.code, 10)
            : isItalianResidence && Boolean(item?.generality?.italianResidence?.municipality?.code)
            ? ID_ITALIAN_NATION
            : undefined,
        nomeStatoResidenza: isForeignResidence
          ? item?.generality?.foreignResidence?.state?.value
          : isItalianResidence && Boolean(item?.generality?.italianResidence?.municipality?.code)
          ? DESCRIPTION_ITALIAN_NATION
          : undefined,
        idComuneResidenza:
          isForeignResidence && item?.generality?.foreignResidence?.municipality?.id
            ? Number?.parseInt(item?.generality?.foreignResidence?.municipality?.id)
            : isItalianResidence
            ? item?.generality?.italianResidence?.municipality?.code || undefined
            : undefined,
        nomeComuneResidenza: isForeignResidence
          ? item?.generality?.foreignResidence?.municipality?.description || undefined
          : isItalianResidence
          ? item?.generality?.italianResidence?.municipality?.description || undefined
          : undefined,
        flagIrreperibile: isNotKnownResidence && item?.generality?.isUntraceable ? '1' : '0',
        idComuneAire: item?.generality?.foreignResidence?.municipalityAire?.code || undefined,
        nomeComuneAire:
          item?.generality?.foreignResidence?.municipalityAire?.description || undefined,
        idProvinciaAire:
          item?.generality?.foreignResidence?.municipalityAire?.idProvince || undefined,
        siglaProvinciaAire:
          item?.generality?.foreignResidence?.municipalityAire?.province || undefined,
        tipoDocRiconoscimento: item?.generality?.documentTypology || undefined,
        numeroDocRiconoscimento: item?.generality?.documentNumber || undefined,
        dataScadenzaDocRicon: item?.generality?.documentExpiryDate
          ? item?.generality?.documentExpiryDate?.toFormat('yyyy-MM-dd')
          : undefined,
        docRiconRilasciatoDa: item?.generality?.documentReleaseFrom || undefined,
        dataRilascioDocRicon: item?.generality?.documentReleaseDate
          ? item?.generality?.documentReleaseDate?.toFormat('yyyy-MM-dd')
          : undefined,
        codiceSoggetto: item?.codeSubject || undefined,
        flagComparente: item?.flagComparente || defaultFlag,
        flagDichiarante: dataTranscription?.applicant?.id
          ? isMadreApplicant || isPadreApplicant || isRichiedenteApplicant || isNascituroApplicant
            ? '1'
            : defaultFlag
          : item?.flagDichiarante || defaultFlag,
        impedimento:
          item.generality?.conditionsItemSignatory?.id &&
          item.generality?.conditionsItemSignatory?.id !== initialConditionsItem.id
            ? item.generality?.conditionsItemSignatory?.id
            : item?.generality?.conditionsItem?.id &&
              item?.generality?.conditionsItem?.id?.toString() !== initialConditionsItem.id
            ? item?.generality?.conditionsItem?.id?.toString()
            : item.generality?.conditionsItemSignatory?.id ||
              item?.generality?.conditionsItem?.id ||
              undefined,
        idFormatoData: item.generality?.formatBirthDate?.id?.toString() || undefined,
        descrizioneFormatoData: item.generality?.formatBirthDate?.value || undefined,
        numeroAnni: item.generality?.age
          ? Number.parseInt(item.generality?.age?.toString(), 10)
          : undefined,
        flagFirmatario: withIsSignatoryCheck(item.configuration || '')
          ? item.generality?.isSignatory
            ? '1'
            : '0'
          : item?.flagFirmatario || defaultFlag,
      } as SoggettoList;
    });
};
